<template>
    <div id="bank-account-information" class="tab-pane fade">
        <div v-if="bankAccounts.length">
            <div class="row">
                <div v-for="account in bankAccounts" class="col-xl-3 col-lg-6 col-md-6 mb-4" :key="account.id">
                    <bank-account-card-component :account="account"/>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-md-12"><p>No bank accounts available.</p></div>
        </div>
    </div>
</template>

<script>
	export default {
		props: ["bankAccounts"]
	};
</script>